function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 162.335 162.335",
    style: {
      enableBackground: "new 0 0 162.335 162.335"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "colorable",
    style: {
      stroke: "#000",
      strokeWidth: "1.5px"
    },
    d: "M105.876,24.715c-30.365,0-55.14,24.124-56.321,54.215H11.421l26.946-26.946 c1.164-1.164,1.164-3.055,0-4.219s-3.055-1.164-4.219,0L2.118,79.801c-0.012,0-0.012,0-0.012,0.006L0,81.913l2.112,2.106 c0,0,0,0,0.012,0.006l32.012,32.024c0.585,0.585,1.354,0.871,2.112,0.871c0.758,0,1.528-0.292,2.112-0.871 c1.158-1.164,1.158-3.055,0-4.219l-26.94-26.934h38.206c1.933,29.387,26.403,52.723,56.262,52.723 c31.123,0,56.447-25.323,56.447-56.453S137.011,24.715,105.876,24.715z M105.888,131.653c-26.564,0-48.361-20.657-50.301-46.756 h47.174c1.641,0,2.983-1.337,2.983-2.983s-1.343-2.983-2.983-2.983H55.504c0.549-12.638,5.669-24.458,14.673-33.456 c9.547-9.535,22.227-14.792,35.706-14.792c27.835,0,50.486,22.644,50.486,50.486S133.724,131.653,105.888,131.653z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyArrow);
export default __webpack_public_path__ + "static/media/policy-arrow.24936a9ed1dee78e9a25b3019c7175c6.svg";
export { ForwardRef as ReactComponent };